import React from 'react';
import { connect } from 'react-redux';

import IngresaCorreo from './ingresaCorreo.cmpt';
import IngresaContrasena from './ingresaContrasena.cmpt';
import UsuarioBloqueado from './usuarioBloqueado.cmpt';
import Preguntas from './preguntas.cmpt';

const mapState = (state) => {
    return {
        loading: state.global.loading,
        paso: state.login.paso
    };
}

const mapDispatch = (dispatch) => {
    return {
        siguientePaso: (iPaso) => {
            dispatch({ "type": "LOGIN_PASO_SIGUIENTE", paso: iPaso});
        },
        limpiarRegistro: () => {
			dispatch({ "type": "LIMPIAR_REGISTRO" });
		},
		resetPaso: () => {
            dispatch({ "type": "LOGIN_RESET_PASO" }); 
        },
    }
}

class Flujo extends React.Component {
    siguiente = () => {
        this.props.siguientePaso(this.props.paso + 1);
    }
    
	componentWillMount = () => {
	    this.props.resetPaso();
		this.props.limpiarRegistro();
	}
    
    render() {
        return (
            <div className="login-wrap">
                <div className="container">
                    <div className="ayuda-wrap">
                        <p>¿Tienes duda de cómo utilizar el portal? <a href="">Ver tutorial</a></p>
                    </div>
                    <div className="login-box">
                        { this.props.paso == 0 && 
                            <IngresaCorreo />
                        }
                        { this.props.paso == 1 && 
                            <IngresaContrasena />
                        }
                        { this.props.paso == 2 && 
                            <Preguntas />
                        }
                        { this.props.paso == 3 && 
                            <UsuarioBloqueado />
                        }
                    </div>
                </div>
            </div>
        )
    }
}

export default connect(mapState, mapDispatch)(Flujo);


// WEBPACK FOOTER //
// ./src/login/flujo.cmpt.js